// removed by extract-text-webpack-plugin
module.exports = {"EditorTooltip":"g6GtbqBryS"};


//////////////////
// WEBPACK FOOTER
// ./src/components/EditorTooltip/EditorTooltip.scss
// module id = 891
// module chunks = 0